const categoriesColorList = [
  '#FFD1DC',
  '#FFABAB',
  '#FFC3A0',
  '#FFE3B3',
  '#FFF5BA',
  '#D4E157',
  '#A9DFBF',
  '#ADE5D0',
  '#A9CCE3',
  '#D6EAF8',
  '#C9A9F5',
  '#F8E1F4',
  '#FFDFDE',
  '#FFF7E3',
  '#FFEFBA',
  '#E0F7FA',
  '#B3E5FC',
  '#FFCCF9',
  '#F5E0DC',
  '#E6C6B2',
  '#FFF5E1',
  '#B2F9FC',
  '#C1E1DC',
  '#BFE9FF',
  '#D1CCFF',
  '#FFE4E1',
  '#DFF9FB',
  '#FADADD',
  '#E0BBE4',
  '#C5FAD5',
];

export default categoriesColorList;
